import * as R from 'ramda';
import { isNullOrUndefined, isArray } from 'util';

export const parseNumber = (value: string) => (isNullOrUndefined(value)) ? null : +value;

export const round = (value: number, decimals = 2) => (!isNullOrUndefined(value)) ? +value.toFixed(decimals) : null;

export const compare = (a: number, b: number) => a - b;

export const getModule = (value: number, max: number, reverse = false) => {
  return (reverse) ? max - (value % max) - 1 : value % max;
};

export const sum = (a: number, b: number) => a + b;

export const isDivisibleBy = R.curry((base: number, value: number) => value % base === 0);

export const isEven = (value: number) => isDivisibleBy(2, value);

export const isNumeric = (value: string) => !isNaN(parseNumber(value));

const fixedValueToNumber = (value: string) => (value) ? parseFloat(value) : null;

export const sumValues = (values: number[]) => (
  isArray(values)) ? fixedValueToNumber(
    (values.reduce((sumValue, value) => sumValue + value, 0)).toFixed(2)) : null;



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/utils/number.utils.ts